import { createAxiosInstance } from "./client";
import { msalInstance } from "./msalInstance";

const axiosInstance = createAxiosInstance(msalInstance);
const ENDPOINT = '/procurement';

export async function getProcurements() {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération des marchés publics.");
  }
}

export async function getProcurementByUuid(uuid) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error; // for catch status in /procurement/index.js
    // throw new Error("Erreur lors de la récupération du marché public.");
  }
}

export async function getIsValidForNextStep(uuid) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}/validator`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la validation du marché.");
  }
}

export async function postProcurement(values) {
  try {
    const response = await axiosInstance.post(`${ENDPOINT}`, values);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la création d'un marché.");
  }
}

export async function updateProcurement(uuid, values) {
  try {
    const response = await axiosInstance.put(`${ENDPOINT}/${uuid}`, values);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de l'édition d'un marché.");
  }
}

export async function getBidderByUuid(uuid, uuidProcurement) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuidProcurement}/bidder/${uuid}`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération d'une entreprise.");
  }
};

export async function removeBidderFromProcurement(uuidProcurement, emails) {
  try {
    const response = await axiosInstance.delete(`${ENDPOINT}/${uuidProcurement}/bidder`, { data: emails });
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération d'une entreprise.");
  }
};

export async function getAttributionByUuidProcurement(uuid) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}/attribution`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération du rapport d'attribution.");
  }
};

export async function convertWordDocumentsToPdf(uuid, documentsOptions) {
  try {
    const response = await axiosInstance.put(`${ENDPOINT}/${uuid}/document`, documentsOptions);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la conversion des documents.");
  }
};

export async function uploadDocument(uuid, file, docType) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `${ENDPOINT}/${uuid}/document`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          type: docType,
        },
      },
    );

    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de l'upload du document.");
  }
};

export async function getOrderByProcurementUuid(uuid) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}/order`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération du bon de commande.");
  }
}
